import { render, staticRenderFns } from "./RecipeInfoForm.vue?vue&type=template&id=2644291d&scoped=true"
import script from "./RecipeInfoForm.vue?vue&type=script&lang=js"
export * from "./RecipeInfoForm.vue?vue&type=script&lang=js"
import style0 from "./RecipeInfoForm.vue?vue&type=style&index=0&id=2644291d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2644291d",
  null
  
)

export default component.exports